import { ButtonHTMLAttributes, FC } from 'react'

import { cx } from 'utils/cx'

import s from './s.module.scss'

const ButtonGradient: FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({ className, ...props }) => {
  return (
    <button {...props} className={cx(s.button, className)}>
      {props.children}
    </button>
  )
}

export default ButtonGradient
